import gql from 'graphql-tag'
import { client, removeTypenames } from './api'
import { Account } from './integrations'

export interface ExperimentationGroup {
  id: string
  title: string
  accounts: string[]
  domains: string[]
  creationDate: string
  lastModifiedDate: string
}

export interface ExperimentationGroupInput {
  id?: string
  title: string
  accounts: string[]
  domains: string[]
}

export const getExperimentationGroupsAndAccountsQuery = gql`
  query {
    experimentGroups {
      id
      title
      accounts
      domains
      creationDate
      lastModifiedDate
    }
    allAccounts {
      account
      displayName
      domains
    }
  }
`

export interface ExperimentationGroupsAndAccountsQueryResponse {
  experimentGroups: ExperimentationGroup[]
  allAccounts: Account[]
}

export async function getExperimentationGroupsAndAccounts() {
  return client.query({
    query: getExperimentationGroupsAndAccountsQuery,
    variables: {},
    fetchPolicy: 'network-only',
  })
}

export async function createExperimentationGroup(
  experimentationGroup: ExperimentationGroupInput
) {
  removeTypenames(experimentationGroup)
  return client
    .mutate({
      mutation: gql`
        mutation (
          $title: String!
          $accounts: [String!]!
          $domains: [String!]!
        ) {
          experimentGroups {
            create(title: $title, accounts: $accounts, domains: $domains) {
              id
            }
          }
        }
      `,
      variables: experimentationGroup,
    })
    .catch(() => {
      throw new Error('Cannot create experimentation group')
    })
}

export async function editExperimentationGroup(
  experimentationGroup: ExperimentationGroupInput
) {
  removeTypenames(experimentationGroup)
  return client
    .mutate({
      mutation: gql`
        mutation (
          $id: String!
          $title: String!
          $accounts: [String!]!
          $domains: [String!]!
        ) {
          experimentGroups {
            edit(
              id: $id
              title: $title
              accounts: $accounts
              domains: $domains
            ) {
              id
            }
          }
        }
      `,
      variables: experimentationGroup,
    })
    .catch(() => {
      throw new Error('Cannot edit experimentation group')
    })
}

export async function deleteExperimentationGroup(
  experimentationGroupId: string
) {
  return client
    .mutate({
      mutation: gql`
        mutation ($id: String!) {
          experimentGroups {
            delete(id: $id)
          }
        }
      `,
      variables: {
        id: experimentationGroupId,
      },
    })
    .catch(() => {
      throw new Error('Cannot delete experimentation group')
    })
}
